import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function TermsOfUse() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <>
 <section className="faq terms-nd-condition web-site">
   <div className='container'>
  <h2>{t('termsOfUse.title')}</h2>
  <p>
    {t('termsOfUse.introduction')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.useOfWebsite.title')}</h3>
  <p>
    {t('termsOfUse.sections.useOfWebsite.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.intellectualProperty.title')}</h3>
  <p>
    {t('termsOfUse.sections.intellectualProperty.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.serviceInformation.title')}</h3>
  <p>
    {t('termsOfUse.sections.serviceInformation.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.limitationOfLiability.title')}</h3>
  <p>
    {t('termsOfUse.sections.limitationOfLiability.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.jurisdiction.title')}</h3>
  <p>
    {t('termsOfUse.sections.jurisdiction.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('termsOfUse.sections.contact.title')}</h3>
  <p>
    {t('termsOfUse.sections.contact.description')}: <a href="mailto:admin@roam4less.app" className='email'>admin@roam4less.app</a>
  </p>
  </div>
</section>

 </>
  );
}

export default TermsOfUse;
